import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "@mui/material";
import CustomTable from "../../components/customTable/CustomTable";
import { useSnackbar } from "notistack";
import { useAdminContext } from "../../Hooks/AdminContext";
import StatusChip from "../../theme/chip";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
import { useNavigate } from "react-router-dom";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Icon } from "@iconify/react";
import FilteredChip from "../../components/FilteredChip";
import CustomDrawer from "../../components/CustomDrawer";
import TransactionsFilter from "./TransactionsFilter";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import { formatNumber, show_proper_words } from "../../utils/constant";
import { _List_Transaction_For_Admin } from "../../DAL/Listing/TransactionList";
import moment from "moment";
import { Scree_Base_List } from "../../DAL/Listing/AgencyAddAcount";

const PaymentRequest = ({ dashboard }) => {
  const { setnavbarTitle } = useAdminContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [selectUsersList, setSelectUsersList] = useState([]);
  const EMPTY_FILTER = {
    user: "",
    status_value: "",
    payment_made_by: "",
  };
  const [filterDrawerState, setFilterDrawerState] = useState(false);
  const [filterData, setFilterData] = useState(EMPTY_FILTER);
  const [filterStateUpdated, setFilterStateUpdated] = useState(EMPTY_FILTER);
  const [userList, setUserList] = useState([]);
  const [userList1, setUserList1] = useState([]);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // This function handles page changes for pagination.
  // It updates the page state to the new page number and adjusts the page count accordingly.
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };

  // This function handles changes in the number of rows per page for pagination.
  // It updates the rowsPerPage state to the new value and resets the page state to 0.
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // This function handles the page change for pagination.
  // If the new page is less than or equal to 0, it resets the page to 0 and sets the page count to 1.
  // Otherwise, it updates the page state to the new page and adjusts the page count accordingly.
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };

  /**
   * Updates the filter data state dynamically based on input field changes.
   *
   * @param {string} name - The key in the filter object to update.
   * @param {any} value - The new value to assign to the specified key.
   */
  const handleChangeOthers = (name, value) => {
    setFilterData((values) => ({ ...values, [name]: value }));
  };

  /**
   * Opens the filter drawer by setting its state to true.
   */
  const handleOpenFilterDrawer = () => {
    setFilterDrawerState(true);
  };

  /**
   * Closes the filter drawer by setting its state to false.
   */
  const handleCloseFilterDrawer = () => {
    setFilterDrawerState(false);
  };

  /**
   * Table column definitions for the User Deposit Requests table.
   * Includes dynamic rendering logic for actions, user info, method, amount, date, and status.
   */
  const User_Table_Head = [
    {
      id: "action",
      label: "Action",
      renderData: (row) => (
        <>
          <Tooltip title="View Detail" placement="top">
            <RemoveRedEyeIcon
              onClick={() => {
                if (dashboard) {
                  navigate(`/dashboard/deposit-detail/${row._id}`);
                } else {
                  navigate(`/deposit-request/deposit-detail/${row._id}`);
                }
              }}
              style={{ fill: "#fff", marginRight: "10px", cursor: "pointer" }}
            />
          </Tooltip>
        </>
      ),
    },
    {
      id: "number",
      label: "#",
      type: "number",
    },
    {
      id: "user",
      label: "User",
      renderData: (row) => (
        <span
          className="pointer"
          onClick={() => navigate(`/deposit-request/deposit-detail/${row._id}`)}
        >
          {row.user_info.first_name + " " + row.user_info.last_name || "_ _"}
          <div className="text-muted small">{row.user_info.email || "_ _"}</div>
        </span>
      ),
    },
    // {
    //   id: "name",
    //   label: "Request Title",
    // },
    {
      id: "deposit_method",
      label: "Deposit Method",
      renderData: (row) => (
        <div>
          {row.deposit_method === "crypto"
            ? "Crypto Transfer"
            : row.deposit_method === "credit_card"
            ? "Credit Card Transfer"
            : show_proper_words(row.deposit_method) || "_ _"}
        </div>
      ),
    },
    {
      id: "amount",
      label: "Amount",
      renderData: (row) => <div>${formatNumber(row.total_amount) || "0"}</div>,
    },
    {
      id: "transaction_date",
      label: "Transaction Date",
      renderData: (row) => (
        <div>{moment(row.date_time).format("DD MMM YY hh:mm A") || "_ _"}</div>
      ),
    },
    {
      id: "status",
      label: "Status",
      renderData: (row) => (
        <StatusChip
          status={
            row.status === "succeeded"
              ? "Approved"
              : row.status === "failed"
              ? "Rejected"
              : row.status === "requires_action"
              ? "Needs Changes"
              : "Pending"
          }
          type="activeInactive"
        />
      ),
    },
  ];

  /**
   * Executes search logic for the deposit transactions list.
   * - Resets pagination
   * - Persists search and filter state in localStorage
   * - Fetches filtered transaction data
   * - Closes the filter drawer
   */
  const searchFunction = () => {
    setPage(0);
    setTotalPages(1);
    localStorage.setItem("All_Deposit_List_Search_Text", searchText);
    localStorage.setItem(
      "FilterData_Subscription_Payments_List",
      JSON.stringify(filterData)
    );
    getTransactionsList(0, rowsPerPage, filterData, searchText);
    handleCloseFilterDrawer();
  };

  /**
   * Clears all applied filters for the subscription payments list.
   * - Removes saved filter data from localStorage
   * - Resets filter state to default
   * - Resets pagination
   * - Fetches full transaction list without filters
   * - Closes the filter drawer
   */
  const handleClearFilter = () => {
    localStorage.removeItem("FilterData_Subscription_Payments_List");
    setFilterData(EMPTY_FILTER);
    setPage(0);
    setPageCount(1);
    getTransactionsList(0, rowsPerPage, EMPTY_FILTER, searchText);
    handleCloseFilterDrawer();
  };

  /**
   * Handles the deletion of a filter chip and updates the list accordingly.
   * - Ensures required filter keys exist in the data object.
   * - Resets pagination to first page.
   * - Updates the transaction list based on the modified filter.
   * - Updates the localStorage with the new filter state.
   */
  const HandleDeleteChip = (data) => {
    if (!data.user) {
      data.user = "";
    }
    if (!data.payment_made_by) {
      data.payment_made_by = "";
    }
    setPage(0);
    getTransactionsList(0, rowsPerPage, data, searchText);
    setFilterData(data);
    localStorage.setItem(
      "FilterData_Subscription_Payments_List",
      JSON.stringify(data)
    );
  };

  /**
   * Fetches the list of wallet transactions for the admin based on provided filters.
   *
   * @param {number} page - Current page number for pagination.
   * @param {number} rowsPerPage - Number of rows to show per page.
   * @param {object} filterData - Filter object containing user, status, and payment method.
   * @param {string} search - Search text for transaction filtering.
   *
   * Flow:
   * - Prepares the `formData` object using specific fields from `filterData`.
   * - Calls the `_List_Transaction_For_Admin` API.
   * - On success:
   *   - Formats chip display data for selected filters.
   *   - Updates UI state: total count, pages, transaction list, chip state.
   * - On failure:
   *   - Displays error via snackbar.
   */
  const getTransactionsList = async (page, rowsPerPage, filterData, search) => {
    const PostData = { ...filterData };
    PostData.search = search;
    // console.log(PostData);

    const formData = {
      type: "wallet",
      user_id: filterData?.user?.id || "",
      status: filterData?.status_value || "",
      payment_method: filterData?.payment_made_by || "",
    };
    setLoading(true);
    const response = await _List_Transaction_For_Admin(
      formData,
      page,
      rowsPerPage
    );
    if (response.code === 200) {
      const { total_count, total_pages, transaction = [] } = response;
      let chipData = { ...filterData };
      if (chipData?.user?.id) {
        chipData.user = {
          chip_label: chipData?.user?.name,
          chip_value: chipData?.user?.id,
        };
      }
      if (chipData.payment_made_by) {
        chipData.payment_made_by = show_proper_words(chipData.payment_made_by);
      }
      if (chipData.status_value) {
        chipData.status_value =
          chipData.status_value === "succeeded"
            ? "Approved"
            : chipData.status_value === "failed"
            ? "Rejected"
            : chipData.status_value === "requires_action"
            ? "Needs Changes"
            : "Pending";
      }

      // console.log(chipData, "chipDatachipDatachipDatachipDatachipData");
      setFilterStateUpdated(chipData);
      setTotalCount(total_count);
      setTotalPages(total_pages);
      setUserList(transaction);
      dashboard && setUserList1(transaction);
      setLoading(false);
    } else {
      setLoading(false);
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };

  /**
   * Fetches and formats a list of customers based on search input.
   *
   * @param {string} value - The search keyword used to filter users.
   *
   * Flow:
   * - Sends a request to `Scree_Base_List` with type set to `"customer"`.
   * - On success:
   *   - Maps the response to a formatted array with `id`, `name`, and `email`.
   *   - Updates `selectUsersList` state with formatted data.
   */
  const handleGetDetailUser = async (value) => {
    const FormData = {
      type: "customer",
      search: value,
    };
    const response = await Scree_Base_List(FormData);
    if (response.code === 200) {
      const FormatData = response?.list?.map((value) => {
        return {
          id: value.user_id,
          name: show_proper_words(value.first_name + " " + value.last_name),
          email: value.email,
        };
      });
      setSelectUsersList(FormatData);
    }
  };

  /**
   * useEffect triggered on mount and when pagination values change.
   *
   * Responsibilities:
   * 1. Fetch default user list using `handleGetDetailUser`.
   * 2. Set navbar title if not in dashboard context.
   * 3. Restore filter and search state from `localStorage`.
   * 4. Determine which filters to apply and call `getTransactionsList`.
   * 5. Update search input state if a stored value exists.
   *
   * Dependencies:
   * - Triggers whenever `page` or `rowsPerPage` changes.
   */
  useEffect(() => {
    handleGetDetailUser();
    if (!dashboard) {
      setnavbarTitle("Deposit Request");
    }
    const StoredFilter =
      JSON.parse(
        localStorage.getItem("FilterData_Subscription_Payments_List")
      ) || {};
    const search = localStorage.getItem("All_Deposit_List_Search_Text");
    if (Object.keys(StoredFilter).length > 0) {
      setFilterData(StoredFilter);
      setFilterStateUpdated(StoredFilter);
    }
    const finalFilter =
      Object.keys(StoredFilter).length > 0 ? StoredFilter : filterData;
    getTransactionsList(page, rowsPerPage, finalFilter, search || "");
    if (search) setSearchText(search);
  }, [page, rowsPerPage]);

  if (loading) {
    return <CustomCircularProgress />;
  }

  return (
    <div className="mt-3">
      {dashboard ? (
        <h5 className="my-2">Pending Wallet Deposit Requests</h5>
      ) : (
        <div className="row mb-3">
          <div className="col-12 col-md-9">
            <FilteredChip
              data={filterStateUpdated}
              tempState={filterData}
              EMPTY_FILTER={EMPTY_FILTER}
              onDeleteChip={HandleDeleteChip}
              onClear={handleClearFilter}
            />
          </div>
          <div className="col-12 col-md-3 text-end">
            <Button variant="contained" onClick={handleOpenFilterDrawer}>
              Filters &nbsp;&nbsp; <Icon icon={roundFilterList} />
            </Button>
          </div>
        </div>
      )}

      <CustomTable
        data={dashboard ? userList1 : userList}
        TABLE_HEAD={User_Table_Head}
        MENU_OPTIONS={[]}
        // custom_search={{
        //   searchText: searchText,
        //   setSearchText: setSearchText,
        //   handleSubmit: searchFunction,
        // }}
        custom_pagination={{
          total_count: totalCount,
          rows_per_page: rowsPerPage,
          page: page,
          handleChangePage: handleChangePage,
          onRowsPerPageChange: handleChangeRowsPerPage,
        }}
        pageCount={pageCount}
        totalPages={totalPages}
        handleChangePages={handleChangePages}
        pagePagination={dashboard ? false : true}
        is_hide={true}
        placeHoldertext={"Search by user"}
      />
      <CustomDrawer
        isOpenDrawer={filterDrawerState}
        onOpenDrawer={handleOpenFilterDrawer}
        onCloseDrawer={handleCloseFilterDrawer}
        pageTitle="Filters"
        componentToPassDown={
          <TransactionsFilter
            filterData={filterData}
            userList={selectUsersList}
            handleGetDetailUser={handleGetDetailUser}
            handleClearFilter={handleClearFilter}
            handleChangeOthers={handleChangeOthers}
            searchSubmitFilter={searchFunction}
            setFilterData={setFilterData}
            deposit={true}
          />
        }
      />
    </div>
  );
};

export default PaymentRequest;
